import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewUI from 'view-design'
import util from '@/libs/util'
import Cookies from 'js-cookie'
import store from '@/store'

import {menuRouters, otherRouters, routers} from './router'

Vue.use(VueRouter)

// 路由配置
const RouterConfig = {
  routes: routers
}

export const router = new VueRouter(RouterConfig)

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start()
  util.title()

  if (to.meta && to.meta.whiteList) {
    next()
    return
  }

  if (to.name !== 'login' && util.loginTimeOut()) { // 判断登录是否已经超时
    next({name: 'login'})
    return
  }

  // 跳转到对应路由
  if (!Cookies.get('account') && to.name !== 'login') { // 判断是否已经登录且前往的页面不是登录页
    next({name: 'login'})
  } else {
    const has = store.getters['user/has']
    const curRouterObj = util.getRouterObjByName([...otherRouters, ...menuRouters], to.name)
    if (curRouterObj && curRouterObj.has !== undefined) { // 需要判断权限的路由
      if (has(curRouterObj.has)) {
        util.checkLoginChanged(store, to, router)
        util.toDefaultPage([...otherRouters, ...menuRouters], to.name, router, next)
      } else {
        next({replace: true, name: 'login'})
      }
    } else { // 没有配置权限的路由, 直接通过
      util.checkLoginChanged(store, to, router)
      util.toDefaultPage([...routers], to.name, router, next)
    }
  }
})

router.afterEach((to) => {
  util.openNewPage(router.app, to.name, to.params, to.query)
  ViewUI.LoadingBar.finish()
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/router/index.js